import * as Moment from "moment";
const toTeaserProps = (p)=>({
        headingLevel: 'h2',
        title: p.Title,
        intro: p.Description,
        label: Moment(p.PublicationDate).format('LL'),
        imageAlt: p.ImageAlt,
        imageUrl: p.ImageUrls['400x280'],
        imageUrlFallback: p.ImageUrls['4x3'],
        imageUrlLarge: p.ImageUrls['800x560'],
        linkUrl: p.Url,
        key: `news_item_${p.EntityId}`
    });
export const fetchRecentNews = (count)=>async ()=>{
        let headers = new Headers();
        headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
        const response = await fetch(`/api/v1/search/list?type=news&page=0&pageSize=${count}`, {
            headers
        });
        if (response.ok) {
            const body = await response.json();
            return {
                kind: "result",
                value: body.Results.map(toTeaserProps),
                status: response.status
            };
        }
        return {
            kind: "failed",
            status: response.status
        };
    };
